// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1SwTL","addWidgetButton":"Header_addWidgetButton__1hpZN","dashboardTabs":"Header_dashboardTabs__2s77D","active":"Header_active__1gNFu"};